import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
import Language from './Language.vue';
import Mentions from './Mentions.vue';
export default {
  name: 'MentionsLanguage',
  components: {
    Language: Language,
    Mentions: Mentions
  },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};